import { render, staticRenderFns } from "./PreventiveHealthAndVacination.vue?vue&type=template&id=51d54484&"
import script from "./PreventiveHealthAndVacination.vue?vue&type=script&lang=js&"
export * from "./PreventiveHealthAndVacination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports